import {Menu as MenuDto} from "@sobr/wine-menu-client/dist/api";
import React, {ReactElement} from "react";
import {Link} from "react-router-dom";
import {Menu} from "@headlessui/react";
import {ReactComponent as Ellipsis} from "components/Icons/ellipsis.svg";
import {ReactComponent as Pencil} from "components/Icons/pencil.svg";
import {FormattedDate, FormattedMessage, FormattedTime} from "react-intl";
import {ReactComponent as Trash} from "components/Icons/trash.svg";
import {ReactComponent as Copy} from "components/Icons/copy.svg";
import {useAppDispatch} from "../../../lib/redux/hooks";
import {menuManagementActions} from "./menuManagementSlice";
import { MenuDocument } from "features/editor/MenuDocumentModel";
import WeinkarteImage from "components/Images/menu-images/weinkarte.png";
import LeafletImage from "components/Images/menu-images/tischsteller.png";
import AperitifImage from "components/Images/menu-images/aperitif.png";
import LabelImage from "components/Images/menu-images/label.png";

export interface MenuCardProps {
    menu: MenuDto
}

export function MenuCard(props: MenuCardProps): ReactElement {
    const dispatch = useAppDispatch();
    const openRenameModal = () => dispatch(menuManagementActions.openRenameModal(props.menu));
    const openDeleteModal = () => dispatch(menuManagementActions.openDeleteModal(props.menu));
    const openCopyModal = () => dispatch(menuManagementActions.openCopyModal(props.menu));

    let imageUrl = "start-left.png";

    const itemType = (props.menu as any).type as MenuDocument['type'];
    switch (itemType) {
        case "wine":
            imageUrl = WeinkarteImage;
            break;
        case "leaflet": 
            imageUrl = LeafletImage;
            break;
        case "label" as any:
            imageUrl = LabelImage;
            break;
        case "aperitif" as any:
            imageUrl = AperitifImage;
            break;
    }

    return (
        <div className="w-full rounded-lg overflow-visible
                        bg-white shadow-wine-card">
            <Link to={`edit/${props.menu.id}`}>
                <img src={imageUrl} alt="glasses" className="rounded-t-lg object-cover w-full"/>
            </Link>
            <div className="px-4 py-6 font-fira-sans">
                <div className="flex items-center">
                    <h2 className="flex-auto leading-loose text-sm uppercase">
                        {props.menu.name}
                    </h2>
                    <div className="flex-none">
                        <Menu as="div" className="relative">
                            <Menu.Button><Ellipsis className="text-secondary" /></Menu.Button>
                            <Menu.Items className="absolute right-0 origin-top-right
                                                   rounded-md drop-shadow-dropdown-menu bg-white
                                                   font-barlow text-base py-4 z-popover">
                                <Menu.Item>
                                    <button className="flex items-center gap-3 px-4 py-2 w-full hover:bg-warm-gray"
                                            onClick={openRenameModal}>
                                        <span className="flex-none text-secondary"><Pencil className="w-5 h-5" /></span>
                                        <span className="flex-grow text-left"><FormattedMessage id="management.rename" /></span>
                                    </button>
                                </Menu.Item>
                                <Menu.Item>
                                    <button className="flex items-center gap-3 px-4 py-2 w-full hover:bg-warm-gray"
                                            onClick={openDeleteModal}>
                                        <span className="flex-none text-secondary"><Trash className="w-5 h-5" /></span>
                                        <span className="flex-grow text-left"><FormattedMessage id="management.delete" /></span>
                                    </button>
                                </Menu.Item>
                                <Menu.Item>
                                    <button className="flex items-center gap-3 px-4 py-2 w-full hover:bg-warm-gray"
                                            onClick={openCopyModal}>
                                        <span className="flex-none text-secondary"><Copy className="w-5 h-5" /></span>
                                        <span className="flex-grow text-left"><FormattedMessage id="management.copy" /></span>
                                    </button>
                                </Menu.Item>
                            </Menu.Items>
                        </Menu>
                    </div>
                </div>
                <p className="text-xs text-light-text leading-loose">
                    <FormattedDate
                        value={props.menu.lastModified}
                        year="numeric"
                        month="long"
                        day="numeric"
                    />&nbsp;
                    <FormattedTime value={props.menu.lastModified} />
                </p>
            </div>
        </div>
    );
}
